import { Action, Dispatch } from 'redux'
import { db } from 'firebase/index'
import { CampaignType } from 'types/campaign'
import { fetchCampaignsAction } from 'reducks/campaign/actions'

const fetchCampaigns = () => {
  return async (dispatch: Dispatch<Action>) => {
    const campaigns = await db
      .collection('campaigns')
      .orderBy('period_start', 'desc')
      .get()
      .then((snapshots) => {
        const _campaigns: CampaignType[] = []
        snapshots.forEach((snapshot) => {
          const data = snapshot.data() as CampaignType
          data.campaign_id = snapshot.id
          _campaigns.push(data)
        })
        return _campaigns
      })
    dispatch(fetchCampaignsAction(campaigns))
  }
}

export default fetchCampaigns
